<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Branch Name"
                  v-model="branch.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="Code"
                  label="Branch Code"
                  v-model="branch.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="address"
                  label="Address"
                  v-model="branch.address"
                  type="text"
                  :rules="rules.addressRules(500, 'Address')"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="Description"
                  label="Description"
                  v-model="branch.description"
                  type="text"
                  :rules="rules.descriptionRules(500, 'Description')"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="branch.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="branch.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="branch.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="branch.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="branch.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="branch.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="branch.id">
                <v-switch
                  :label="`Status is ${statusFlag ? 'Active' : 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid || saveLoading"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>
  
  <script>
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
import { BranchFormRules } from "../../helpers/validation-rules";
import { branchService } from "../../services/branch-service";
import { Branch } from "../../models/model";

export default {
  name: "BranchDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Branch",
        disabled: false,
        to: "branchs",
      },
      {
        text: "Branch Details",
        disabled: true,
      },
    ],
    createdDate: "",
    updatedDate: "",
    responseError: "",
    saveLoading: false,
    statusFlag: true,
    rules: new BranchFormRules(),
    branch: new Branch(),
    oldBranch: new Branch(),
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new branch
    } else {
      this.getBranchDetail(id);
    }
  },

  methods: {
    getBranchDetail(id) {
      branchService.getBranchDetail(id).then((res) => {
        this.branch = res.data;
        this.createdDate = commonService.formatDate(
          new Date(this.branch.createdDateInMilliSeconds)
            .toISOString()
            .substring(0, 10),
          "YYYY-MM-DD"
        );
        this.updatedDate = commonService.formatDate(
          new Date(this.branch.updatedDateInMilliSeconds)
            .toISOString()
            .substring(0, 10),
          "YYYY-MM-DD"
        );
        this.oldBranch = Object.assign({}, res.data);
        this.statusFlag = this.branch.status == "ACTIVE" ? true : false;
      });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          this.branch.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
          branchService
            .saveBranch(this.branch)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.branch.id) {
        this.branch = new Branch();
        this.statusFlag = true;
      } else {
        this.branch = Object.assign({}, this.oldBranch);
        this.statusFlag = this.branch.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/branchs");
    },
  },
};
</script>
  